(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp-native-background-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dp-background-video')) {
    customElements.define('dp-background-video', class extends HTMLElement {
      connectedCallback() {
        this.player = this.querySelector('video');
        this.hidePlayer = () => this.removeAttribute('data-playing');
        this.showPlayer = () => {
          const reveal = () => { if (!this.player.paused && this.player.readyState >= 2) this.setAttribute('data-playing', ''); };
          if (this.player.requestVideoFrameCallback) this.player.requestVideoFrameCallback(reveal);
          else reveal();
        };
        this.player.addEventListener('playing', this.showPlayer);
        ['pause', 'waiting', 'error', 'emptied'].forEach(event => this.player.addEventListener(event, this.hidePlayer));
        this.player.muted = true;
        this.player.defaultMuted = true;
        this.screen = window.matchMedia('(max-width: 767px)');
        this.carousel = this.closest('slideshow-hero');
        this.update = () => {
          const variant = this.screen.matches ? 'mobile' : 'desktop';
          this.player.poster = this.dataset[variant + 'Poster'];
          const selected = !this.carousel || Number(this.carousel.getAttribute('selected-index') || 0) === Number(this.dataset.slideIndex);
          if (!this.visible || !selected || document.hidden) { this.player.pause(); return; }
          const source = this.dataset[variant];
          if (this.currentSource !== source) {
            this.hidePlayer();
            this.currentSource = source;
            this.player.src = source;
            this.player.load();
          }
          this.player.play().catch(this.hidePlayer);
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
        if (this.carousel) {
          this.selectionObserver = new MutationObserver(this.update);
          this.selectionObserver.observe(this.carousel, { attributes: true, attributeFilter: ['selected-index'] });
        }
        this.screen.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        document.addEventListener('touchend', this.update, { passive: true });
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.selectionObserver?.disconnect();
        this.screen?.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        document.removeEventListener('touchend', this.update);
        this.player?.pause();
        this.player?.removeEventListener('playing', this.showPlayer);
        ['pause', 'waiting', 'error', 'emptied'].forEach(event => this.player?.removeEventListener(event, this.hidePlayer));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
